"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _Icon = _interopRequireDefault(require("../../Icon"));

var _reactSelect = require("react-select");

var DropdownIndicatorWrapper = function DropdownIndicatorWrapper(props) {
  return React.createElement(_reactSelect.components.DropdownIndicator, props, React.createElement(_Icon.default, {
    type: "caret-down",
    variant: "solid"
  }));
};

var _default = DropdownIndicatorWrapper;
exports.default = _default;